import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';

import Cache from './Cache';

import RelatorioService from '../../services/Relatorio';
import { errors } from '../../services/API';

import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Title from '../../components/Title/Title';
import Toast from '../../components/Toast/Toast';
import Filters from '../../components/Filters/Filters';
import Loading from '../../components/Loading/Loading';
import Boolean from '../../components/Inputs/Boolean/Boolean';

import DadosMedalhas from '../../forms/Relatorio/DadosMedalhas';
import EscolaFilter from '../../forms/Escola/EscolaFilterFields';
import EnderecoFilter from '../../forms/Endereco/EnderecoFilter';
import DependenciaAdministrativaFilter from '../../forms/DependenciaAdministrativa/DependenciaAdministrativaFilter';
import { ButtonExport } from '../../forms/Buttons/ButtonsExport';

import AuthorizedElement from '../../security/AuthorizedElement';
import { __RELATORIO_MEDALHAS_EXPORTAR } from '../../security/RoleConfiguration';

import { download } from '../../helper/FileHelper';

import { Layout } from '../../layouts/private/Private';

export class Medalhas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        comObjetoPostalMedalhas: '',
      },
      ultimaChamada: '',
      loading: true,
      schools: [],
    }
  }

  // DECLARAÇÃO DE REFERÊNCIA DOS COMPONENTES
  setToast = t => this.Toast = t;
  setEscolaFilter = form => this.EscolaFilter = form;
  setEnderecoFilter = f => this.EnderecoFilter = f;
  setDependenciaAdministrativaFilter = d => this.DependenciaAdministrativaFilter = d;

  // INPUTS
  handleChange = e => {
    this.setState({
      filters: {...this.state.filters,  [e.target.name]: e.target.value }
    });
  };

  // FILTROS
  ApplyFilters = () => {
    this.setState({ loading: true });

    const f = [];
    const { filters } = this.state;
    const filtersEscola = this.EscolaFilter.state.filters;
    const filtersEndereco = this.EnderecoFilter.state.filters;
    const filtersDepAdm = this.DependenciaAdministrativaFilter.state.filters;

    if (filtersEscola.inepSchool) f.push({ field: 'cdEscola', value: filtersEscola.inepSchool })
    if (filtersEndereco.UF) f.push({ field: 'cdUf', value: filtersEndereco.UF })
    if (filtersDepAdm.adminDep) f.push({ field: 'nmDependenciaAdministrativa', value: filtersDepAdm.adminDep })

    if (filters.comObjetoPostalMedalhas !== '') f.push({ field: 'comObjetoPostalMedalhas', value: filters.comObjetoPostalMedalhas })

    f.push({ field: 'forceRefresh', value: true });

    RelatorioService.filtersReportMedalhas(f)
      .then(res => {
        this.setState({ 
          ultimaChamada: res.data.ultimaChamada,
          loading: false,
          schools: [ ...res.data.cache ]
        });
      })
      .catch(error => {
        this.setState({ loading: false });
      })
  }

  // EXPORTAÇÃO
  handleExportChange = () => {
    const f = [];
    const { filters } = this.state;
    const filtersEscola = this.EscolaFilter.state.filters;
    const filtersEndereco = this.EnderecoFilter.state.filters;
    const filtersDepAdm = this.DependenciaAdministrativaFilter.state.filters;

    if (filtersEscola.inepSchool) f.push({ field: 'cdEscola', value: filtersEscola.inepSchool })
    if (filtersEndereco.UF) f.push({ field: 'cdUf', value: filtersEndereco.UF })
    if (filtersDepAdm.adminDep) f.push({ field: 'nmDependenciaAdministrativa', value: filtersDepAdm.adminDep })

    if (filters.comObjetoPostalMedalhas !== '') f.push({ field: 'comObjetoPostalMedalhas', value: filters.comObjetoPostalMedalhas })

    f.push({ field: 'forceRefresh', value: true });
    f.push({ field: 'exportarPlanilha', value: true });

    this.Toast.setState({
      message: {
        message: "A Planilha está sendo gerada para Exportação.",
        type: 'info',
        open: true,
        loading: true,
        autoHide: false,
      }
    })

    RelatorioService.exportReportMedalhas(f)
      .then(res => download(res))
  }

  buscarEscolas = (forceRefresh = false) => {
    this.setState({ loading: true });
    const filters = [{ 'field': "forceRefresh", 'value': forceRefresh }];

    RelatorioService.filtersReportMedalhas(filters)
      .then(res => {        
        this.setState({ 
          filters: {
            comObjetoPostalMedalhas: '',
          },
          ultimaChamada: res.data.ultimaChamada,
          loading: false,
          schools: [ ...res.data.cache ]
        });   
      })
      .catch(error => {
        const e = errors(error);
        this.setState({ loading: false });

        this.Toast.setState({
          message: {
            message: e.message,
            type: e.type,
            open: true
          }
        })
      });
  }

  componentDidMount() { 
    this.buscarEscolas();
  }

  // LIMPAR FILTROS
  handleFilterClear = () => {
    this.setState({
      filters: {
        comObjetoPostalMedalhas: '',
      }
    })

    this.EscolaFilter.setState({
      filters: {
        inepSchool: '',
      }
    })

    this.EnderecoFilter.setState({
      filters: {
        UF: '',
      }
    })

    this.DependenciaAdministrativaFilter.setState({
      filters: {
        adminDep: '',
      }
    })
  }

  render() {
    const pageName = 'Medalhas';
    const links = [
      {
        path: null,
        name: 'Relatórios'
      }
    ];

    return (
      <Layout>
        <Toast parentRef={this.setToast} />
        <Grid container >
          <Grid item xs={12}>
            <Breadcrumbs links={links} active={pageName} />
          </Grid>
        </Grid>
        <Title>
          {pageName}
          { this.state.ultimaChamada && 
            <Cache ultimaAtualizacao={this.state.ultimaChamada} action={() => this.buscarEscolas(true)} /> 
          }
        </Title>

        <Filters
          handleFilter={this.ApplyFilters}
          handleFilterClear={this.handleFilterClear}
        >
          <Grid item container spacing={3}>
            <EscolaFilter
              parentRef={this.setEscolaFilter}
              disabledEmail={true}
              disabledNameSchool={true}
            />
            <EnderecoFilter
              parentRef={this.setEnderecoFilter}
              disabledCities={true}
            />
            <DependenciaAdministrativaFilter
              parentRef={this.setDependenciaAdministrativaFilter}
              withPublicGroup={true}
            />
            <Grid item sm={12} lg={3}>
              <Boolean
                label="Com Objeto Postal de Medalhas para Premiação?"
                name='comObjetoPostalMedalhas'
                value={this.state.filters.comObjetoPostalMedalhas}
                onChange={(e) => this.handleChange(e)}
              />
            </Grid>
          </Grid>
        </Filters>
        <Grid container >
          <AuthorizedElement roles={[__RELATORIO_MEDALHAS_EXPORTAR]}>
            <ButtonExport
              title="Exportar Planilha"
              onClick={this.handleExportChange}
            />
          </AuthorizedElement>
        </Grid>

        {this.state.loading ?
          <Loading />
          :
          <DadosMedalhas schools={this.state.schools} />
        }
      </Layout>
    )
  }
}

export default withRouter(Medalhas);